// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'check';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='m4.464 9.936 1.872 2.592c.216.36.72.432 1.08.216.072-.072.144-.144.216-.144l5.904-7.416'
  />
);

export const viewBox = '0 0 18 18';
